import React from 'react';
import PropTypes from 'prop-types';
import FormField from '../../forms/_common/FormField';
import { OutlineButton, SolidButton } from '../../components/Button';
import FormTemplate from '../../dialogs_common/FormTemplate';
import FormSection from '../../pages/_post-opportunity/forms/FormSection';
import RadioButtonField from '../../pages/_post-opportunity/_fields/RadioButtonField.cards';
import FormTemplateButtonFooter from '../../dialogs_common/FormTemplateButtonFooter';
import { useConfig } from '@lore/config';

InactiveSiteForm.propTypes = {
  data: PropTypes.object,
  errors: PropTypes.object,
  showErrors: PropTypes.bool,
  alert: PropTypes.node,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  activityTypes: PropTypes.object,
  ages: PropTypes.object
};

InactiveSiteForm.defaultProps = {
  // data: {},
  errors: {},
  showErrors: false,
  onChange: () => {}
};

export default function InactiveSiteForm(props) {
  const {
    data,
    errors,
    showErrors,
    alert,
    onChange,
    onPrevious,
    onSubmit,
    onCancel
  } = props;

  const config = useConfig();

  const learnMoreLink = (
    <a href="https://www.communityshare.org" target="_blank" className="underline hover:text-cs-orange-300">
      Contact us here
    </a>
  );

  const contactusLink = (
    <span
      className="underline text-cs-orange-500 hover:text-cs-orange-300 cursor-pointer"
      onClick={() => window.Intercom('show')}
    >
      let us know
    </span>
  );

  return (
    <FormTemplate
      title="Sorry, this site isn't currently active."
      onClose={onCancel}
      alert={alert}
      body={(
        <div className="space-y-6">
          <div>
            Projects and events can only be created on active sites.
          </div>
          <div>
            In the past, only school districts and large networks could join
            CommunityShare. However, we're currently piloting a program for
            individual schools and organizations to join.
          </div>
          <ul className="list-disc ml-6">
            <li>
              Interested in activating your site? {learnMoreLink}.
            </li>
            {config.intercom.enabled && (
              <li>
                If you believe you’ve received this message in error, please {contactusLink}.
              </li>
            )}
          </ul>
        </div>
      )}
      footer={(
        <FormTemplateButtonFooter>
          <OutlineButton onClick={onPrevious}>
            Back
          </OutlineButton>
          {/*<SolidButton onClick={onSubmit}>*/}
          {/*  Next*/}
          {/*</SolidButton>*/}
        </FormTemplateButtonFooter>
      )}
    />
  );
}
